function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

function cubicBezier(P0, P1, P2, P3, t) {
  var x = (1 - t) ** 3 * P0[0] + 3 * (1 - t) ** 2 * t * P1[0] + 3 * (1 - t) * t ** 2 * P2[0] + t ** 3 * P3[0];
  var y = (1 - t) ** 3 * P0[1] + 3 * (1 - t) ** 2 * t * P1[1] + 3 * (1 - t) * t ** 2 * P2[1] + t ** 3 * P3[1];
  return [x, y];
}

// Generate ear with continuous parameters (no discrete types)
function generateEar(startPoint, isLeft = false) {
  let direction = isLeft ? -1 : 1;

  // All continuous random parameters
  let earWidth = randomFromInterval(15, 42);
  let earLength = randomFromInterval(28, 72);

  // Ear angle: -1 (hanging down) to 1 (pointing up)
  let earAngle = randomFromInterval(-0.85, 0.95);

  // Ear spread: how wide the ear opens (0.3 to 0.8)
  let earSpread = randomFromInterval(0.3, 0.8);

  // Ear curve: how curved vs straight (0.1 to 1.2)
  let earCurve = randomFromInterval(0.1, 1.2);

  // Tip offset: lateral displacement of ear tip
  let tipOffset = randomFromInterval(0.05, 0.5);

  let earPoints = [];
  earPoints.push(startPoint);

  // Calculate tip position based on angle
  let tipY = startPoint[1] + earLength * (1 - earAngle) * 0.5 - earLength * earAngle * 0.5;
  let tipX = startPoint[0] + direction * earWidth * tipOffset;

  // Outer edge control points influenced by angle and curve
  let outerCtrl1X = startPoint[0] + direction * earWidth * earSpread * 0.6;
  let outerCtrl1Y = startPoint[1] + earLength * (0.2 - earAngle * 0.3);

  let outerCtrl2X = startPoint[0] + direction * earWidth * earSpread * earCurve;
  let outerCtrl2Y = startPoint[1] + earLength * (0.5 - earAngle * 0.35);

  // Outer edge
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      startPoint,
      [outerCtrl1X, outerCtrl1Y],
      [outerCtrl2X, outerCtrl2Y],
      [tipX, tipY],
      t
    );
    earPoints.push(point);
  }

  // Inner edge control points
  let innerCtrl1X = startPoint[0] + direction * earWidth * (tipOffset - 0.15);
  let innerCtrl1Y = startPoint[1] + earLength * (0.55 - earAngle * 0.4);

  let innerCtrl2X = startPoint[0] + direction * earWidth * 0.05;
  let innerCtrl2Y = startPoint[1] - earLength * earAngle * 0.15;

  // Inner edge back to start
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [tipX, tipY],
      [innerCtrl1X, innerCtrl1Y],
      [innerCtrl2X, innerCtrl2Y],
      startPoint,
      t
    );
    earPoints.push(point);
  }

  return earPoints;
}

export function generateBothEars(leftEarPoint, rightEarPoint, headWidth, headHeight) {
  // Each ear is independently generated with random continuous parameters
  // This naturally creates variety - sometimes similar, sometimes asymmetric
  let leftEar = generateEar(leftEarPoint, true);
  let rightEar = generateEar(rightEarPoint, false);

  return { left: leftEar, right: rightEar };
}
